"use client";
import React, { useState } from "react";
import {
  Flex,
  Box,
  FormControl,
  Input,
  Stack,
  Button,
  Text,
  FormErrorMessage,
  InputGroup,
  InputRightElement,
  FormLabel,
} from "@chakra-ui/react";

import { FiEye, FiEyeOff } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { sendLogin } from "../redux/reducers/app/login";
import { userRegistrationForm } from "../constants/constants";
import H1 from "../Theme/Typography/H1";
// import LoginSlider from "../CommonComponents/LoginSlider";
import { useFormik } from "formik";
import * as Yup from "yup";

export default function Login() {
  const [showPassword, setShowPassword] = useState(false);
  // const [successMsgFlag, setSuccessMsgFlag] = useState(false);
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session);

  let navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        // .email('Please enter a valid email address')
        .required(userRegistrationForm.LOGIN_FORM_USERNAME_VALIDATION_MESSAGE),
      password: Yup.string().required(
        userRegistrationForm.LOGIN_FORM_PASSWORD_VALIDATION_MESSAGE,
      ),
    }),

    onSubmit: (values) => {
      const payload = {
        username: values.email,
        password: values.password,
      };
      dispatch(sendLogin(payload));
    },
  });

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  if (session && session.isAuthenticated) {
    return navigate(`/`);
  }

  return (
    <Flex
      minH={"100vh"}
      align={"center"}
      justify={"center"}
      // bg={useColorModeValue('gray.50', 'gray.800')}
    >
      <Stack spacing={8} mx={"auto"} maxW={"xl"} py={12} px={6}>
        <Stack align={"center"}>
          <Text fontSize={"34px"} fontWeight={"700"}>
            Sign in to your account
          </Text>
        </Stack>
        <Box
          width={"500px"}
          rounded={"lg"}
          // bg={useColorModeValue('white', 'gray.700')}
          boxShadow={"lg"}
          p={8}
        >
          {/* <Stack spacing={4}>
            <FormControl id="email">
              <FormLabel>Email address</FormLabel>
              <Input type="email" />
            </FormControl>
            <FormControl id="password">
              <FormLabel>Password</FormLabel>
              <Input type="password" />
            </FormControl>
            <Stack spacing={10}>
              <Stack
                direction={{ base: 'column', sm: 'row' }}
                align={'start'}
                justify={'space-between'}>
                <Checkbox>Remember me</Checkbox>
                <Text color={'blue.400'}>Forgot password?</Text>
              </Stack>
              <Button
                bg={'blue.400'}
                color={'white'}
                _hover={{
                  bg: 'blue.500',
                }}>
                Sign in
              </Button>
            </Stack>
          </Stack> */}
          <form onSubmit={formik.handleSubmit}>
            <Stack spacing={4}>
              <FormControl
                id="email"
                isInvalid={formik.touched.email && !!formik.errors.email}
              >
                <FormLabel fontWeight={"700"}>Username</FormLabel>
                <Input
                  id="email"
                  borderColor={"color.lightgray2"}
                  name="email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                />
                <FormErrorMessage>{formik.errors.email}</FormErrorMessage>
              </FormControl>

              <FormControl
                id="password"
                isInvalid={formik.touched.password && !!formik.errors.password}
              >
                <FormLabel fontWeight={"700"}>Password</FormLabel>
                <InputGroup>
                  <Input
                    id="password"
                    name="password"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                    borderColor={"color.lightgray2"}
                    _placeholder={{ color: "color.gray" }}
                    type={showPassword ? "text" : "password"}
                  />
                  <InputRightElement>
                    <Text onClick={toggleShowPassword}>
                      {showPassword ? (
                        <FiEye size={"18px"} />
                      ) : (
                        <FiEyeOff size={"18px"} />
                      )}
                    </Text>
                  </InputRightElement>
                </InputGroup>
                <FormErrorMessage>{formik.errors.password}</FormErrorMessage>
              </FormControl>
              <Button
                bg={"blue.400"}
                color={"white"}
                _hover={{
                  bg: "blue.500",
                }}
                variant="custom"
                width={"100%"}
                type="submit"
                isLoading={session.loading}
                loadingText={
                  <H1>
                    {userRegistrationForm.REGISTRATION_FORM_BUTTON_LOGIN_LABEL}{" "}
                    ...
                  </H1>
                }
                spinnerPlacement="end"
              >
                <H1>
                  {userRegistrationForm.REGISTRATION_FORM_BUTTON_LOGIN_LABEL}
                </H1>
              </Button>
              <Text>{session?.error?.message}</Text>
            </Stack>
          </form>
        </Box>
      </Stack>
    </Flex>
  );
}
